import React from 'react';
import PropTypes from 'prop-types';
import { useConnect, UseQueryConnect } from '@lore/query-connect';
import { BuildingOfficeIcon } from '@heroicons/react/24/outline';
import IconSection from '../../../components/IconSection';
const CACHE_TTL = 60 * 60 * 1000; // 1 hour - sites do not change often

Sites.propTypes = {
  user: PropTypes.object.isRequired
};

export default function Sites(props) {
  const { user } = props;

  const roles = useConnect('role.find', {
    where: {
      eager: {
        $where: {
          userId: user.id
        }
      }
    }, pagination: {
      page: 1, pageSize: 2, order: 'createdAt desc'
    }
  }, {cacheTime: CACHE_TTL * 2, staleTime: CACHE_TTL, refetchOnWindowFocus: false});

  if (roles.data.length === 0) {
    return null;
  }
  const totalCount = (roles.meta && roles.meta.totalCount) || 0;
  const totalExtra = Math.max(0, totalCount - roles.data.length);

  return (
    <>
      {roles.data.map(function(role) {
        return (
            <UseQueryConnect key={role.id} _key="site.byId" params={{id: role.data.siteId}}>
              {function (site) {
                return (
                  <IconSection
                    icon={BuildingOfficeIcon}
                    title={role.data.title}
                    subtitle={site.data.name}
                    xs={true}
                  />
                );
              }}
            </UseQueryConnect>
        );
      })}
      {totalExtra > 0 && <p className="text-xs">+ {totalExtra} more sites</p>}
    </>
  );
}
